import { Button, Modal, Form, message } from "antd";
import { useContext, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FiUser } from "react-icons/fi";
import getInitials from "../../../../utils/getInitials";
import { handleRemoveApprover } from "../../../../api/units";
import { AuthContext } from "../../../../contexts/AuthContext";

export default function RemoveApprover({
  isVisible,
  setVisible,
  type,
  selected,
  approver,
}: any) {
  const { setUnit } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleRemoveApprover,
    onSuccess: (data) => {
      setUnit(data);
      message.success("Updated Successfully");
      form.resetFields();
      setVisible(false);
      queryClient.invalidateQueries({ queryKey: ["units"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const data = { approverId: approver?._id, type };
    await mutate({ _id: selected?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title={`Remove ${type}`}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="removeApprover"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
          danger
        >
          Remove
        </Button>,
      ]}
    >
      <Form
        id="removeApprover"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div>Are you sure you want to remove {type}</div>
        <div className="relative rounded-lg w-96  group">
          <div className="flex flex-col">
            <div className=" flex p-2">
              <div className="w-14 h-14 rounded-md border flex flex-col justify-center items-center bg-gray-200">
                <FiUser size={20} />
                <div className="text-xs">{getInitials(approver?.name)}</div>
              </div>
              <div className="flex flex-col justify-center mx-2">
                <div className="font-bold text-md">{approver?.name}</div>
                <div className="text-xs">Email: {approver?.email}</div>
                <div className="text-xs">Mobile: {approver?.mobile}</div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
